import { useEffect } from "react";
import { App as CapApp } from "@capacitor/app";
import { isATTSupported, getATTStatus, requestATT, markATTDecided, setTrackingDisabled } from "@/lib/att";
import api from "@/lib/api";

// Shows Apple's tracking prompt right after launch, before any tracking SDK starts.
// iOS ignores the request unless the app is fully active, so we wait a moment and
// retry each time the app comes back to the foreground until the user answers.
export function ATTLaunchPrompt() {
  useEffect(() => {
    if (!isATTSupported()) { markATTDecided("unavailable"); return; }
    let done = false;
    let timer;
    // Admin switch: Admin → "تتبع الإعلانات (iOS)". Unknown (offline) → keep tracking on.
    const allowed = api.get("/feature-flags", { timeout: 6000 })
      .then((r) => r?.data?.ios_tracking !== false).catch(() => true);
    const tryAsk = async () => {
      if (done) return;
      if (!(await allowed)) { done = true; setTrackingDisabled(); return; }
      const status = await getATTStatus();
      if (status !== "notDetermined") { done = true; markATTDecided(status); return; }
      const res = await requestATT();
      if (res !== "notDetermined") done = true;
    };
    timer = setTimeout(tryAsk, 1000);
    const sub = CapApp.addListener("appStateChange", ({ isActive }) => {
      if (isActive && !done) { clearTimeout(timer); timer = setTimeout(tryAsk, 800); }
    });
    return () => { clearTimeout(timer); sub.then((s) => s.remove()).catch(() => {}); };
  }, []);
  return null;
}
